<template>
  <div class="home">
    <div class="container">
      <section class="section" style="text-align: center">
        <h1 class="title">Welcome to the Lookup Engine Management UI</h1>
        <h2 class="subtitle">A place where lookup engine keys can be modified!</h2>
        <p>To start navigating use the links in the navbar at the top of the page</p>
        <br />
        <p>If you dont see any buttons on the navbar at the top this is probably because you are a new user or don't have permissions.<br /></p>
        <p>To gain access please contact one of the <strong>Voice Developers</strong></p>
        <br />
        <p>If you find any bugs or issues with this UI slack <strong>Joe Garlick</strong> or <strong>John Myers</strong></p>
      </section>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
//import Navbar from "@/views/common/NavbarView.vue";

export default {
  name: "landing",
  components: {},
};
</script>
